export default "__VITE_ASSET__CaNi9L8T__"